import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';

interface ShellProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function Shell({ title, subtitle, action, children }: ShellProps) {
  return (
    <div className="flex h-svh">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={title} subtitle={subtitle} action={action} />
        <main className="min-h-0 flex-1 overflow-y-auto bg-slate-50 px-6 py-6">{children}</main>
      </div>
    </div>
  );
}
